import axios from 'axios';

const getURL = () => `${process.env.API_URL}/api`;

function increase(type, callbackfunction) {
  if (type === 'pdf') {
    console.log('pdf');
    // return this.increasePDF(type, callbackfunction);
  } else if (typeof callbackfunction === 'undefined') {
    axios({
      url: `${getURL()}/gps.incrementStatistic?type=${type}`,
      method: 'GET',
      withCredentials: true,
    }).then((res) => {
      console.log(res);
    });
  } else {
    axios({
      url: `${getURL()}/gps.incrementStatistic?type=${type}`,
      method: 'GET',
      withCredentials: true,
    }).then(() => {
      callbackfunction();
    });
    // jQuery.ajax({url:"/ajax/members/incrementStatistic/", data:{type:type},
    //     success: callbackfunction
    // });
  }
}

function increasePDF() {
  // jQuery.getJSON('/ajax/members/checkLimits?type=pdf', function (responce) {
  //   if (responce.code == 200) {
  //     jQuery.ajax({
  //       url: '/ajax/members/incrementStatistic/',
  //       data: { type },
  //       success: callbackfunction,
  //     });
  //   } else {
  //     jQuery('#global_title_pro').click();
  //     setTimeout(function () {
  //       alert('Sorry. Month limits are 5 PDF download.');
  //     }, 0);
  //   }
  // });
}

export const ToolboxStatistic = {
  increase,
  increasePDF,
};
